import { useState } from "react";

export default function CurrencyExchangeInformation({ currencyData }: any) {
  const [showViewMore, setShowViewMore] = useState<boolean>(true);

  const handleOnClick = () => {
    setShowViewMore(!showViewMore);
  };

  if (!currencyData?.footer?.section_footer?.[1]) {
    return null;
  }

  return (
    <>
      <div className="separator"></div>
      <h2 className="h2">{currencyData?.footer?.section_footer?.[1]?.title}</h2>
      <ul className={`capSulesList grid4 ${!showViewMore ? "showAll" : ""}`}>
        {currencyData?.footer?.section_footer?.[1]?.links?.map(
          (card: any, index: number) => {
            return card?.map((item: any) => {
              return (
                <li key={`${item?.title}${index}`} className="capsule">
                  <a href={item?.href} target="_self" rel="noreferrer">
                    {item?.title}
                  </a>
                </li>
              );
            });
          }
        )}
      </ul>
      <p className="viewMore">
        <a className="viewMore__cta" onClick={() => handleOnClick()}>
          {showViewMore ? "Show More" : "Show Less"}
        </a>
      </p>
    </>
  );
}
